import { assetUrl } from '../config/asset-config';

(function () {
    'use strict';

    angular.module('thankview.global')
        .directive('overlaySeeExample', ['$rootScope', 'ajax', '$compile', '$templateCache', '$templateRequest', 'hubspotService', function ($rootScope, ajax, $compile, $templateCache, $templateRequest, hubspotService) {
            return {
                restrict: 'E',
                scope: true,
                link: function (scope, element) {
                    $templateRequest('/templates/global/overlay-see-example.html?v=' + config.version).then(() => {
                        var template = $compile($templateCache.get('/templates/global/overlay-see-example.html?v=' + config.version))(scope);

                        var inputParent = element.parent()[0];
                        inputParent.insertBefore(template[0], element[0]);
                    });

                    scope.$on('open-see-example', function () {
                        scope.$broadcast('open-overlay');
                    });

                    scope.init = () => {
                        scope.initHubspotForm();
                    };

                    scope.initHubspotForm = () => {
                        hubspotService.loadSeeExampleForm({
                            sfdcCampaignId: '7011Q0000017IkfQAE',
                            target: '#hspot-see-example',
                            onFormSubmit: scope.postLead,
                            onFormSubmitted: scope.exampleSubmitted,
                        });
                    };

                    scope.postLead = (form) => {
                        const name = form.firstname.value + (form.lastname.value ? ' ' + form.lastname.value : '');

                        var params = {
                            name: name,
                            email: form.email.value,
                        };

                        ajax.post('/api/lead/example', params);
                    };

                    scope.exampleSubmitted = () => {
                        scope.$broadcast('force-close-overlay');

                        const message = `<img class="block width-75 sm-width-67 margin-center margin-t-16px margin-b-16px" src="${assetUrl('assets/img/huzzah_uni_2020.png')}" /><p>A ThankView is flying to your inbox!</p>`;
                        $rootScope.$broadcast('open-message', message, { header: 'Hooray!' });
                    };

                    scope.init();
                },
            };
        }]);
}());
